/**
 *
 * @/functions/groups.js
 *
 */

//
// IMPORTS
//

import { getUserUID } from '@/services/endpoints/session'
import { isValidImage } from '@/mixins/utils.js'
import groupplaceholder from '@/assets/images/groupplaceholder.png'

//
//
//

export const isValidGroupImage = imageUrl => !!imageUrl === true && typeof imageUrl === 'string' && imageUrl.indexOf('https://') !== -1
export const sanitizeGroupImage = imageUrl => !!imageUrl === true && typeof imageUrl === 'string' && imageUrl.indexOf('&token=') !== -1 ? imageUrl.split('&token=')[0] : imageUrl
export const validateGroupName = text => String(text).trim().length >= 3 && String(text).trim().length <= 64
export const validateGroupDescription = text => String(text).trim().length >= 3 && String(text).trim().length <= 128
export const validateLocationName = text => String(text).trim().length >= 3 && String(text).trim().length <= 64

// --- LOCAIS DO GRUPO

export const processGroupLocations = group => {
  const groupPlaces = !!group === true && !!group.locais === true && typeof group.locais === 'object' ? Object.entries(group.locais) : []

  return groupPlaces.map(([groupPlaceID, local]) => {
    if (!!local === false) return false

    const groupPlaceName = String(local.nome || '').trim()
    const groupPlaceLatitude = local.latitude || false
    const groupPlaceLongitude = local.longitude || false
    const groupPlaceRadius = local.radius || false
    const groupPlaceTimestamp = local.timestamp || false

    if (!!groupPlaceName === false && !!groupPlaceLatitude === false && !!groupPlaceLongitude === false && !!groupPlaceRadius === false && !!groupPlaceTimestamp === false) return false

    return {
      groupPlaceID,
      groupPlaceName,
      groupPlaceLatitude,
      groupPlaceLongitude,
      groupPlaceRadius,
      groupPlaceTimestamp,
      isGroupLocationGeofenced: !!groupPlaceLatitude === true && !!groupPlaceLongitude === true && !!groupPlaceRadius === true,
    }
  }).filter(filtro => !!filtro === true)
}

export const buildGroupObject = (groupID, g) => {
  // Usuários do grupo
  const groupUsers = g.users || {}

  // Nível do usuário logado dentro do grupo
  const viewerID = getUserUID()
  const viewerLevel = (groupUsers?.[viewerID]?.master || false) === true ? "MASTER" : (
    (groupUsers?.[viewerID]?.admin || false) === true ? "ADMIN" : "MEMBER"
  )

  // Saída
  return {
    groupID,

    groupImage: isValidImage(g.img || '') ? String(g.img).trim() : groupplaceholder,
    groupName: !!g.nome === true && typeof g.nome === 'string' ? g.nome.trim() : '',
    groupDescription: !!g.des === true && typeof g.des === 'string' ? g.des.trim() : '',
    groupCnpj: g.cnpj ? g.cnpj.trim() : '',

    presetLocations: g.fixLocais,
    groupLocations: processGroupLocations(g),

    allowCreateDuty: g.allowCreateDuty || false,
    allowPassDuty: g.allowPassDuty || false,
    startShiftOnDayOnly: g.startShiftOnDayOnly || false,
    allowPauseDuringShift: g.allowPauseDuringShift || false,
    allowDutySplitting: g.allowDutySplitting || false,
    disableShiftStart: g.disableShiftStart || false,
    disableShiftEnd: g.disableShiftEnd || false,
    remindShiftStart: g.remindShiftStart || false,
    hideDutyValue: g.hideDutyValue || false,
    hideGroupShiftsTab: g.hideGroupShiftsTab || false,

    approvePassDuty: g.approvePassDuty || false,
    whoCanAcceptOrRefuse: !!g.approvePassDuty === true && !!g.whoCanAcceptOrRefuse === true && g.whoCanAcceptOrRefuse === 'apenas_gestores',

    allowDutyCandidates: g.allowDutyCandidates || false,
    disablePassToGroupAndUser: g.disablePassToGroupAndUser || false,
    disablePassToGroup: g.disablePassToGroup || false,
    sequentialShiftConflicts: g.sequentialShiftConflicts || false,
    sequentialShiftConflictsInterval: g.sequentialShiftConflictsInterval ? g.sequentialShiftConflictsInterval : '60',

    checkinWindow: g.checkinWindow || null,
    checkoutWindow: g.checkoutWindow || null,

    groupUsers,
    viewerLevel,

    // groupInviteID: g.idconvite ? g.idconvite.trim() : '',

    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    requireSosPortalAppointmentKeys: g.requireSosPortalAppointmentKeys || false,
    // maxConsultationRequestDayOfMonth: !!g.maxConsultationRequestDayOfMonth === true ? g.maxConsultationRequestDayOfMonth : false,
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */
  }
}
